import { ReactElement } from 'react'
import { TopNavigationBar } from '../TopNavigation/index'
import {
  LogoImage,
  WhiteBackgroundEnd,
  BlackBackground,
  ShoppingCartMenuIcon,
} from '../TopNavigation/components/CommonMenuItems'
import { HeaderProps } from './HeaderProps'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { totalProductsQtyInCart } from 'cart'

const CartOnlyHeader = (props: HeaderProps): ReactElement => {
  const { logoUrl } = props
  const totalQtyInCart: number = useSelector((state: RootState) =>
    totalProductsQtyInCart(state)
  )

  return (
    <TopNavigationBar>
      <BlackBackground>
        <LogoImage src={logoUrl} alt="My place 4 parts logo" />
      </BlackBackground>
      <WhiteBackgroundEnd>
        <ShoppingCartMenuIcon qty={totalQtyInCart} />
      </WhiteBackgroundEnd>
    </TopNavigationBar>
  )
}

export default CartOnlyHeader
